import { defaultDropAnimationSideEffects } from '@dnd-kit/core';

import type { DropAnimation } from '@dnd-kit/core';

export const EQUIPMENT_DROP_ANIMATION: DropAnimation = {
    duration: 180,
    easing: 'cubic-bezier(0.2, 0, 0, 1)',
    sideEffects: defaultDropAnimationSideEffects({
        styles: {
            active: {
                opacity: '0',
            },
        },
    }),
};
